import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("attributes.sandbox.request_title"))),
      ]),
      _vm._t("default"),
      _c(VBreadcrumbs, { staticClass: "pa-0 py-2 text--black" }, [
        _vm._v(
          " " + _vm._s(_vm.$t("attributes.sandbox.request_subtitle")) + " "
        ),
      ]),
      _c(VRow, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              VCard,
              [
                _c(VRow, { staticClass: "justify-center" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-7 mt-2" },
                    [
                      _vm.stepperReady
                        ? _c(
                            VStepper,
                            {
                              model: {
                                value: _vm.sandbox_stepper,
                                callback: function ($$v) {
                                  _vm.sandbox_stepper = $$v
                                },
                                expression: "sandbox_stepper",
                              },
                            },
                            [
                              _c(
                                VStepperHeader,
                                [
                                  _c(
                                    VStepperStep,
                                    {
                                      attrs: {
                                        step: "01",
                                        complete:
                                          parseInt(_vm.sandbox_stepper) > 1,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "attributes.sandbox.attribute_selection"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(VDivider, {
                                    attrs: { color: _vm.color_step_1 },
                                  }),
                                  _c(
                                    VStepperStep,
                                    {
                                      attrs: {
                                        step: "02",
                                        complete:
                                          parseInt(_vm.sandbox_stepper) > 2,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("attributes.sandbox.request")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VStepperItems,
                                [
                                  _c(
                                    VStepperContent,
                                    { attrs: { step: "01" } },
                                    [
                                      _c(
                                        VRow,
                                        [
                                          _c(
                                            VCol,
                                            { attrs: { sm: "12" } },
                                            [
                                              _c(
                                                "h4",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "attributes.sandbox.attribute_selection"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "attributes.sandbox.confirm"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "attributes.sandbox.this_is_add"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "attributes.sandbox.quantity_attributes"
                                                    )
                                                  ) + ": "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "font-weight-bold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.attributes.length
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                              _c(
                                                VRow,
                                                { attrs: { "no-gutters": "" } },
                                                [
                                                  _c(
                                                    VCol,
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                      attrs: { cols: "12" },
                                                    },
                                                    [
                                                      _c(
                                                        VBtn,
                                                        {
                                                          staticClass:
                                                            "mb-2 btn-block-xs-only",
                                                          attrs: {
                                                            outlined: "",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.goToSearch,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            VIcon,
                                                            {
                                                              attrs: {
                                                                left: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "icon-search"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "attributes.button.search"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        VBtn,
                                                        {
                                                          staticClass:
                                                            "ml-md-1 mb-2 btn-block-xs-only",
                                                          attrs: {
                                                            type: "button",
                                                            color: "primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.click_sandobx_stepper(
                                                                "02"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            VIcon,
                                                            {
                                                              attrs: {
                                                                left: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "icon-check"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "attributes.button.confirm"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        VBtn,
                                                        {
                                                          staticClass:
                                                            "ml-md-1 mb-2 btn-block-xs-only",
                                                          attrs: {
                                                            outlined: "",
                                                            type: "button",
                                                            color: "error",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.$refs[
                                                                _vm
                                                                  .DIALOG_CANCEL_SANDBOX_REQUEST
                                                              ].onOpen()
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            VIcon,
                                                            {
                                                              attrs: {
                                                                left: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-cancel"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.cancel"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VStepperContent,
                                    { attrs: { step: "02" } },
                                    [
                                      _c(
                                        VRow,
                                        [
                                          _c(
                                            VCol,
                                            { attrs: { sm: "12" } },
                                            [
                                              _c(
                                                "h4",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "attributes.sandbox.request"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "attributes.sandbox.complete_form"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _c(
                                                VForm,
                                                {
                                                  ref: "form",
                                                  attrs: {
                                                    "lazy-validation": "",
                                                  },
                                                  model: {
                                                    value: _vm.valid,
                                                    callback: function ($$v) {
                                                      _vm.valid = $$v
                                                    },
                                                    expression: "valid",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    VRow,
                                                    {
                                                      attrs: {
                                                        "no-gutters": "",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        VCol,
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            md: "6",
                                                          },
                                                        },
                                                        [
                                                          _c(VTextField, {
                                                            attrs: {
                                                              label:
                                                                _vm.label
                                                                  .use_case_name,
                                                              placeholder:
                                                                _vm.label
                                                                  .use_case_name,
                                                              name: "useCaseRequest.business_name",
                                                              rules:
                                                                _vm.rules
                                                                  .businessName,
                                                              outlined: "",
                                                              dense: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .useCaseRequest
                                                                  .business_name,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.useCaseRequest,
                                                                    "business_name",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "useCaseRequest.business_name",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        VCol,
                                                        {
                                                          staticClass:
                                                            "pl-md-1",
                                                          attrs: {
                                                            cols: "12",
                                                            md: "6",
                                                          },
                                                        },
                                                        [
                                                          !_vm.flagCustomExpirationSbx
                                                            ? _c(VSelect, {
                                                                attrs: {
                                                                  label:
                                                                    _vm.label
                                                                      .duration,
                                                                  name: "fecha_id",
                                                                  placeholder:
                                                                    _vm.label
                                                                      .duration,
                                                                  items:
                                                                    _vm.fechas,
                                                                  rules:
                                                                    _vm.rules
                                                                      .period,
                                                                  "item-value":
                                                                    "id",
                                                                  "item-text":
                                                                    "name",
                                                                  outlined: "",
                                                                  dense: "",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.fecha_id,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.fecha_id =
                                                                        $$v
                                                                    },
                                                                  expression:
                                                                    "fecha_id",
                                                                },
                                                              })
                                                            : _vm._e(),
                                                          _vm.flagCustomExpirationSbx
                                                            ? _c(
                                                                "div",
                                                                [
                                                                  _c(
                                                                    "CalendarComponent",
                                                                    {
                                                                      attrs: {
                                                                        placeholder:
                                                                          _vm
                                                                            .label
                                                                            .duration,
                                                                        label:
                                                                          _vm
                                                                            .label
                                                                            .duration,
                                                                        rules:
                                                                          _vm
                                                                            .rules
                                                                            .period,
                                                                        dense: true,
                                                                        outlined: true,
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm.fecha_custom,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.fecha_custom =
                                                                              $$v
                                                                          },
                                                                        expression:
                                                                          "fecha_custom",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        VCol,
                                                        {
                                                          attrs: { cols: "12" },
                                                        },
                                                        [
                                                          _c(VTextarea, {
                                                            attrs: {
                                                              outlined: "",
                                                              name: "useCaseRequest.description_business",
                                                              label:
                                                                _vm.label
                                                                  .detail_use_case,
                                                              placeholder:
                                                                _vm.label
                                                                  .detail_use_case,
                                                              rules:
                                                                _vm.rules
                                                                  .businessDescription,
                                                              rows: "2",
                                                              dense: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .useCaseRequest
                                                                  .description_business,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.useCaseRequest,
                                                                    "description_business",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "useCaseRequest.description_business",
                                                            },
                                                          }),
                                                          _vm
                                                            .businessUserServiceAccounts
                                                            .length
                                                            ? _c(VSelect, {
                                                                attrs: {
                                                                  outlined: "",
                                                                  label:
                                                                    _vm.label
                                                                      .add_sa_by_business_area,
                                                                  items:
                                                                    _vm.businessUserServiceAccounts,
                                                                  "item-value":
                                                                    "email",
                                                                  "item-text":
                                                                    "name",
                                                                  dense: "",
                                                                  rules:
                                                                    _vm.rules
                                                                      .serviceAccount,
                                                                },
                                                                on: {
                                                                  change:
                                                                    _vm.onSelectServiceAccount,
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.service_account,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.service_account =
                                                                        $$v
                                                                    },
                                                                  expression:
                                                                    "service_account",
                                                                },
                                                              })
                                                            : _vm._e(),
                                                          _c(VCombobox, {
                                                            attrs: {
                                                              label:
                                                                _vm.label.users,
                                                              placeholder:
                                                                _vm.label.users,
                                                              multiple: "",
                                                              dense: "",
                                                              outlined: "",
                                                              rules: [
                                                                _vm.ruleEmailMultiSelect,
                                                              ],
                                                              chips: "",
                                                              "append-icon": "",
                                                              "error-messages":
                                                                _vm.errors,
                                                              loading:
                                                                _vm.isLoadingEmail,
                                                              readonly:
                                                                _vm.isLoadingEmail,
                                                            },
                                                            on: {
                                                              input:
                                                                _vm.changeEmail,
                                                              keydown:
                                                                function (
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    !$event.type.indexOf(
                                                                      "key"
                                                                    ) &&
                                                                    _vm._k(
                                                                      $event.keyCode,
                                                                      "space",
                                                                      32,
                                                                      $event.key,
                                                                      [
                                                                        " ",
                                                                        "Spacebar",
                                                                      ]
                                                                    )
                                                                  ) {
                                                                    return null
                                                                  }
                                                                  $event.preventDefault()
                                                                },
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "selection",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var item =
                                                                      ref.item
                                                                    var attrs =
                                                                      ref.attrs
                                                                    var selected =
                                                                      ref.selected
                                                                    var disabled =
                                                                      ref.disabled
                                                                    var parent =
                                                                      ref.parent
                                                                    return [
                                                                      _c(
                                                                        VChip,
                                                                        _vm._b(
                                                                          {
                                                                            key: JSON.stringify(
                                                                              item
                                                                            ),
                                                                            attrs:
                                                                              {
                                                                                "input-value":
                                                                                  selected,
                                                                                disabled:
                                                                                  disabled,
                                                                                close:
                                                                                  _vm.owner_email !==
                                                                                  item,
                                                                                dark: "",
                                                                              },
                                                                            on: {
                                                                              "click:close":
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return parent.selectItem(
                                                                                    item
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          "v-chip",
                                                                          attrs,
                                                                          false
                                                                        ),
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                item
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              false,
                                                              2989788223
                                                            ),
                                                            model: {
                                                              value:
                                                                _vm.newUsers,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.newUsers =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "newUsers",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        VCol,
                                                        {
                                                          staticClass:
                                                            "text-center",
                                                          attrs: { cols: "12" },
                                                        },
                                                        [
                                                          _c(
                                                            VBtn,
                                                            {
                                                              staticClass:
                                                                "mb-2 btn-block-xs-only",
                                                              attrs: {
                                                                outlined: "",
                                                                type: "button",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.click_sandobx_stepper(
                                                                      "01"
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                VIcon,
                                                                {
                                                                  attrs: {
                                                                    left: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-chevron-left"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "attributes.button.back"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            VBtn,
                                                            {
                                                              staticClass:
                                                                "ml-md-1 mb-2 btn-block-xs-only",
                                                              attrs: {
                                                                type: "button",
                                                                color:
                                                                  "primary",
                                                                disabled:
                                                                  _vm.isLoadingEmail,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.click_sandobx_stepper(
                                                                      "03"
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                VIcon,
                                                                {
                                                                  attrs: {
                                                                    left: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "icon-check"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "attributes.button.confirm"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            VBtn,
                                                            {
                                                              staticClass:
                                                                "ml-md-1 mb-2 btn-block-xs-only",
                                                              attrs: {
                                                                outlined: "",
                                                                type: "button",
                                                                color: "error",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$refs[
                                                                      _vm
                                                                        .DIALOG_CANCEL_SANDBOX_REQUEST
                                                                    ].onOpen()
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                VIcon,
                                                                {
                                                                  attrs: {
                                                                    left: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-cancel"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "common.cancel"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("dialogs-component", {
        ref: _vm.DIALOG_ADD_BASE_IDS,
        attrs: {
          title: _vm.$t("titles.add_inca_base"),
          "show-buttons": "",
          width: 950,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("add-base-ids-component", {
                  ref: "addBaseIdComponent",
                  attrs: { "use-case": _vm.useCaseRequest },
                  on: { "update:baseID": _vm.onAddBaseID },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.addBaseIdComponent.onSubmit($event)
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("frases.register")) + " "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialog-confirmation-component", {
        ref: _vm.DIALOG_CANCEL_SANDBOX_REQUEST,
        attrs: {
          text: _vm.$t("warnings.cancel_sandbox_request"),
          title: "Confirmación",
        },
        on: { onConfirm: _vm.onCancelRequest },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }